import { faCircleCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Checkbox } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  marginLeft: "11px",
  marginRight: "8px",
  padding: "0",
  "&.Mui-disabled.MuiCheckbox-root": {
    color: theme.palette.error["main"]
  },
  "&.Mui-disabled.Mui-checked": {
    color: theme.palette.success["main"]
  }
}))

const TodoListCheckbox = ({ checked, updateFieldArray, icon, color, disabled }) => {
  return (
    <StyledCheckbox
      color={color && color}
      disabled={disabled}
      icon={<FontAwesomeIcon size="2x" icon={icon} />}
      checkedIcon={<FontAwesomeIcon size="2x" icon={faCircleCheck} />}
      checked={checked}
      onChange={(item) => {
        const checked = item.target.checked
        updateFieldArray(checked)
      }}
    />
  )
}

export default TodoListCheckbox
